import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const StyledNeonButton = styled(motion.button)`
  position: relative;
  padding: 0.75em 1.5em;
  border-radius: 0.625em;
  border: 2px solid ${props => props.theme.colors.accent};
  font-size: 0.938em;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.125em;
  background: transparent;
  color: ${props => props.theme.colors.accent};
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 0 0 0 transparent;
  transition: all 0.3s ease-in-out;
  font-family: ${props => props.theme.fonts.primary};

  &:hover {
    background: rgba(61, 90, 254, 0.1);
    box-shadow: 0 0 40px 10px rgba(61, 90, 254, 0.5);
    color: ${props => props.theme.colors.white};
  }

  &::before {
    content: "";
    display: block;
    width: 0px;
    height: 86%;
    position: absolute;
    top: 7%;
    left: 0%;
    opacity: 0;
    background: linear-gradient(90deg, transparent, ${props => props.theme.colors.accent}, transparent);
    box-shadow: 0 0 50px 30px ${props => props.theme.colors.accent};
    transform: skewX(-20deg);
    transition: all 0.5s ease-in-out;
  }

  &:hover::before {
    animation: neon-shine 0.6s 0s linear;
  }

  @keyframes neon-shine {
    from {
      opacity: 0;
      left: 0%;
    }

    50% {
      opacity: 1;
    }

    to {
      opacity: 0;
      left: 100%;
    }
  }

  &:active {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }
`;

const NeonButton = ({ 
  children, 
  onClick,
  type = 'button',
  disabled = false,
  ...props 
}) => {
  return (
    <StyledNeonButton
      type={type}
      onClick={onClick}
      disabled={disabled}
      whileTap={{ scale: 0.98 }}
      {...props}
    >
      {children}
    </StyledNeonButton>
  );
};

export default NeonButton; 